import api from "@/lib/axios"

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface StudentProfile {
    name?: string | null
    phone?: string | null
    institution?: string | null
    graduation_year?: number | null
    travel_history?: string | null
    gpa?: number | null
    gpa_scale?: string
    english_test?: "ielts" | "toefl" | "duolingo" | null
    ielts?: number | null
    toefl?: number | null
    duolingo?: number | null
    sat?: number | null
    field?: string | null
    degree_level?: string | null
    efc?: number | null
    funding_preference?: string | null
    competitions?: boolean
    publications?: boolean
    academic_background?: string | null
    email?: string | null
}

export interface MatchedUniversity {
    id: number
    slug: string
    name: string
    state: string | null
    city: string | null
    qs_rank: number | null
    sat_25th: number | null
    sat_75th: number | null
    acceptance_rate: number | null
    min_gpa: number | null
    min_ielts: number | null
    scholarship_name: string | null
    scholarship_amount: number | null
    scholarship_type: string | null
    cost_before: number | null
    cost_after: number | null
    bangladeshis_admitted: boolean | null
    deadline_month: number | null
    deadline_year: number | null
    fields: string[] | null
    degree_levels: string[] | null
    apply_url: string | null
    scholarship_url: string | null
    why_bangladeshi: string | null
    pct_intl_receiving_aid: number | null
    graduation_rate_6yr: number | null
    cds_year: string | null
    match_score: number
    match_tier: "safe" | "match" | "reach"
}

export interface FinderResponse {
    total: number
    matches: MatchedUniversity[]
}

// ---------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------

export const universityFinderService = {
    find: (profile: StudentProfile) =>
        api.post<FinderResponse>("/public/university-finder/find", profile).then(r => r.data),
}
